import React from 'react';
import ViewList from '@mui/icons-material/ViewList';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';
import DocumentTemplateSignatureBookmarkListComponent from './DocumentTemplateSignatureBookmarkListComponent';

const DocumentTemplateSignatureBookmarkListCard = ({
  documentTemplate,
  onSave,
  validation,
  signatureActors,
  saveBookmarksDisabled,
  onPropertyChanged,
  onLookupPropertyChanged,
  onAddNewBookmark,
  onBookmarkDeleted
}) => {
  const [t] = useTranslation();
  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('DocumentTemplate.SignatureBookmarks')}
      actions={
        <>
          <IconButton color='transparent' fontSize='medium' type='add' tooltip={t('Tooltips.Add')} onClick={onAddNewBookmark} />
          <IconButton
            color='transparent'
            fontSize='medium'
            type='save'
            tooltip={t('DocumentTemplate.SaveChanges')}
            onClick={onSave}
            disabled={!documentTemplate.signatureBookmarksChanged || saveBookmarksDisabled}
          />
        </>
      }
    >
      <>
        <Prompt when={documentTemplate.signatureBookmarksChanged} message={t('DocumentTemplate.LeavingWithoutSavingBookmarks')} />
        <DocumentTemplateSignatureBookmarkListComponent
          documentTemplate={documentTemplate}
          signatureActors={signatureActors}
          validation={validation}
          onPropertyChanged={onPropertyChanged}
          onLookupPropertyChanged={onLookupPropertyChanged}
          onAddNewBookmark={onAddNewBookmark}
          onBookmarkDeleted={onBookmarkDeleted}
        />
      </>
    </Card>
  );
};

DocumentTemplateSignatureBookmarkListCard.propTypes = {
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  documentTemplate: PropTypes.object.isRequired,
  signatureActors: PropTypes.array,
  saveBookmarksDisabled: PropTypes.bool.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onLookupPropertyChanged: PropTypes.func.isRequired,
  onAddNewBookmark: PropTypes.func.isRequired,
  onBookmarkDeleted: PropTypes.func.isRequired
};

export default DocumentTemplateSignatureBookmarkListCard;
